// lib/siegerEhrung.js — Daten für das Siegerbild der Formen-/SV-Leinwand
// (21.10.2026). Die Leinwand zeigt dieselbe Bühne wie /siegerehrung-display
// (components/leinwand/SiegerBuehne) mit denselben Daten: Platzierungen aus
// formen_teilnehmer (Endwertung), Fotos nur als foto_frei (Einwilligung) und
// nur mit Hallenschlüssel der Leinwand. Quelle ist die Rangliste der
// Siegerehrung (GET /api/siegerehrung/turnier/:id/ranglisten), gerechnet wird
// hier nichts.

const API_URL = process.env.REACT_APP_API_URL || '';

/** Kategorie für die Bühne laden: { kategorie_name, division_type, plaetze } oder null. */
export async function ladeEhrung({ turnierId, kategorieId, token }) {
  try {
    const r = await fetch(`${API_URL}/api/siegerehrung/turnier/${turnierId}/ranglisten`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const d = await r.json().catch(() => ({}));
    if (!r.ok || !d.success) return null;
    const k = (d.data || []).find((x) => x.typ === 'formen' && String(x.kategorie_id) === String(kategorieId));
    if (!k || !(k.plaetze || []).length) return null;
    return {
      kategorie_name: k.kategorie_name, division_type: k.division_type,
      plaetze: k.plaetze.map((p) => ({
        platzierung: Number(p.platzierung), wettkaempfer_id: p.wettkaempfer_id,
        vorname: p.vorname, nachname: p.nachname, verein_name: p.verein_name,
        punkte: p.punkte, foto_frei: !!p.foto_frei, verein_logo: p.verein_logo || null,
      })),
    };
  } catch {
    return null;
  }
}

/**
 * Was die Bühne aus einem Leinwand-Paket bekommt: die mitgeschickte Ehrung,
 * sonst (ältere Panels) die Rangliste mit ihren Platzierungen.
 */
export function ehrungAusStand(stand) {
  if (stand?.ehrung?.plaetze?.length) return stand.ehrung;
  const liste = (stand?.rangliste || []).filter((p) => Number(p.platzierung) > 0);
  return {
    kategorie_name: stand?.kategorie || '',
    division_type: stand?.disziplin === 'sv' ? 'Selbstverteidigung' : 'Formen',
    plaetze: liste.map((p) => ({ ...p, platzierung: Number(p.platzierung), punkte: p.gesamt_punkte ?? p.punkte ?? null })),
  };
}
